export default __webpack_public_path__ + "static/media/statue.fa28a65c.png";